import { Session } from './../../models/session';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Category } from 'src/app/models/category';
import { Int64Updater } from 'src/app/models/key-value';
import { Urls } from 'src/app/models/urls';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  url = new Urls();
  dcmApiUrl: string;

  constructor(
    private httpclient: HttpClient
  ) {
      this.dcmApiUrl = this.url.dcmApiUrl;
  }

  getSessions(page, size, rid, sid) {
    // tslint:disable-next-line: max-line-length
    const url = this.dcmApiUrl + '/api/session/' + page + '/' + size + '/' + rid + '/' + sid + '/';
    return this.httpclient.get<any>(url)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  postSession(sess: Session) {
    return this.httpclient.post<any>(this.dcmApiUrl + '/api/session', sess)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  putSession(id: string, sess: Session) {
    return this.httpclient.put<any>(this.dcmApiUrl + '/api/session/' + id, sess)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  deleteSession(id: string): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.httpclient.delete<any>(this.dcmApiUrl + '/api/session/' + id, options)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  private handleError(error: any) {
    throw error;
    return error;
  }

}
